/* eslint-disable no-unused-vars */
import { LeaderboardState } from './leaderboard/types';

/**
 * @typedef {object} BrownlowTrackerState
 * @property {LeaderboardState} leaderboard
 */
